"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyLoad = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
/**
 * Only renders the child component when first entered view
 */
var LazyLoad = function (_a) {
    var minHeight = _a.minHeight, minWidth = _a.minWidth, children = _a.children, onLazyLoad = _a.onLazyLoad, _b = _a.style, style = _b === void 0 ? {} : _b;
    var _c = __read((0, react_1.useState)(false), 2), hasEnteredView = _c[0], setHasEnteredView = _c[1];
    var intersectionObserverRef = (0, react_1.useRef)(null);
    var elementRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var element = elementRef.current;
        if (intersectionObserverRef.current || !element) {
            return;
        }
        var observer = new IntersectionObserver(function (e) {
            if (e.some(function (i) { return i.intersectionRatio > 0; })) {
                setHasEnteredView(true);
            }
        });
        intersectionObserverRef.current = observer;
        intersectionObserverRef.current.observe(element);
        return function () {
            observer.unobserve(element);
            intersectionObserverRef.current = null;
        };
    }, []);
    (0, react_1.useEffect)(function () {
        if (hasEnteredView) {
            onLazyLoad === null || onLazyLoad === void 0 ? void 0 : onLazyLoad();
        }
    }, [hasEnteredView, onLazyLoad]);
    return ((0, jsx_runtime_1.jsx)("div", { ref: elementRef, style: __assign({ minHeight: minHeight, minWidth: minWidth, opacity: hasEnteredView ? "1" : "0", transition: "all 1s" }, style), children: hasEnteredView ? children : null }));
};
exports.LazyLoad = LazyLoad;
